module.exports = __webpack_public_path__ + "img/science_hi.74c16d40.jpg";